// extracted by mini-css-extract-plugin
var _1 = "Zpv8T";
export { _1 as "appContainer" }
